export default {
  aria_skip_to_main_content: 'Skip to main content',
  aria_main_navigation: 'Main navigation',
  aria_user_navigation: 'User navigation',
  aria_mobile_navigation_toggle: 'Toggle mobile navigation menu',
  aria_mobile_navigation_menu: 'Mobile navigation menu',
  aria_dropdown_menu: 'Dropdown menu',
  aria_submenu: '{name} submenu',
  more: 'More',
  lang_chooser: {
    aria_label: 'Language Chooser',
    lang_switch: 'Naviguer en',
  },
};
